const whatsappConfig = {
  PHONE: "5569992530641",
};

export default whatsappConfig;
